export default function sendHotjarEvent(event) {
  if (!event || typeof window.hj !== "function") return

  window.hj("event", event)
}
